module.exports = __webpack_public_path__ + "img/GTWM_Main_Logo-02.b90a97ee.png";